import { render, staticRenderFns } from "./ability-type.vue?vue&type=template&id=004ea336&scoped=true"
import script from "./ability-type.vue?vue&type=script&lang=js"
export * from "./ability-type.vue?vue&type=script&lang=js"
import style0 from "./ability-type.vue?vue&type=style&index=0&id=004ea336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ea336",
  null
  
)

export default component.exports